module.exports = __webpack_public_path__ + "static/media/cactus.aa979d02.svg";